<template>
  <div class="flex">
    <SwdSideBar />
    <div class="flex flex-col w-full">
      <Header />
      <SettingsApp />
    </div>
  </div>
</template>

<script>
import SettingsApp from '../views/SettingsApp.vue'

import SwdSideBar from '@/components/Global/SwdSideBar.vue'
import Header from '@/components/Header/Header.vue'

export default {
  name: 'Settings',

  components: {
    SwdSideBar,
    Header,
    SettingsApp,
  },
}
</script>
